import { StatusCode } from 'core/constants';

// What a failed Part Finder request means to the page: refused (403), a family that is not
// available (the server's 404 / 422), or a server or network failure for anything else.
export const getErrorStatusCode = (error: unknown): StatusCode => {
  const status = (error as { response?: { status?: number } })?.response?.status;

  if (status === StatusCode.ACCESS_DENIED) {
    return StatusCode.ACCESS_DENIED;
  }

  if (status === StatusCode.NOT_FOUND || status === 422) {
    return StatusCode.NOT_FOUND;
  }

  return StatusCode.SERVER_ERROR;
};
